export default "__VITE_ASSET__YTHba$6N__"